const getHiddenAttributes = () => {
  const vars = typeof window !== 'undefined' ? window.pmkinoClientVars : undefined
  const hidden = vars && vars.hidden_attributes
  if (Array.isArray(hidden)) {
    return hidden.map(id => String(id).trim())
  }
  return []
}

export default getHiddenAttributes
